import BillingRule from "../entities/billing-rule";
import ClientLike from "@/api/client-like";

export default class BillingRuleApi {
  constructor(private client: ClientLike) {}

  async findByProject(projectId: string): Promise<BillingRule> {
    const rule = await this.client.get("get_billing_rule.php", { projectId });
    return new BillingRule(
      rule.monthRule,
      rule.dayRule || 31,
      rule.cutoffRule || 31
    );
  }
}
